import { HttpServiceResponse } from '../../shared'
import AbstractProvider from '../../shared/abstract.provider'
import { AccEntryAddTypes } from '../models/accEntry.types'

export class AccEntryAddProvider extends AbstractProvider {
  urlPath = 'acc_entry_add_api'

  public add<T>(action: AccEntryAddTypes, params: Record<string, any>): Promise<HttpServiceResponse<T>> {
    const query = this.query.stringify({
      action,
    })

    return this.http.post(`${this.url}?${query}`, params)
  }

  public operAdd<T>(action: AccEntryAddTypes, params: Record<string, any>): Promise<HttpServiceResponse<T>> {
    const url = this.getCustomUrl('acc_conv_add_api')
    const query = this.query.stringify({
      action,
    })

    return this.http.post(`${url}?${query}`, params)
  }
}
